import styled from 'styled-components';
import { css, breakpoints } from 'src/styles/theme';
import { Pages } from 'src/types/pages';
import { SummaryDealerDetailsStyled } from '../../SummaryDealerDetailsStyled';
import { rem } from 'polished';

export const SummaryDealerDetailsOV = styled(SummaryDealerDetailsStyled)`
    border-bottom: ${rem('1px')} solid black;
    border-top: ${rem('1px')} solid black;

    .titleWrapper {
        .isClose {
            svg {
                path {
                    fill: ${({ theme }) => theme.colors.black};
                }
            }
        }
        .isOpen {
            svg {
                path {
                    stroke: ${({ theme }) => theme.colors.black};
                }
            }
        }
    }

    .infoIcon {
        svg g {
            circle {
                fill: ${({ theme }) => theme.colors.black};
                stroke: ${({ theme }) => theme.colors.black};
            }

            line {
                stroke: ${({ theme }) => theme.colors.white};
            }
        }
    }

    .linkButton {
        border: unset;
        text-align: left;
        padding: unset;
        font-weight: bold;
        text-transform: uppercase;
        font-size: ${rem('14px')};
        margin-top: ${rem('16px')};
        color: black;
        cursor: pointer;
        position: relative;
        width: fit-content;
        background: none;

        .txt {
            margin-right: ${rem('7px')};
        }

        .icon-wrapper {
            svg path {
                fill: black !important;
                stroke: black !important;
            }
        }

        &:hover {
            .txt {
                border-bottom: 1px solid black;
            }
        }
    }

    .titleWrapper {
        .title {
            font-size: ${({ theme }) => theme.fontSizes.h3};
        }
    }

    .dealerTitle {
        font-size: ${rem(16)};
    }
`;
